import React, { useEffect, useState, useRef } from 'react';
import { createRoot } from 'react-dom/client';
import { createPortal } from 'react-dom';
import * as Sentry from '@sentry/react';
import { client } from '/Foundation/SitecoreGraphQL/code/client';
const { SitecoreSiteName } = window._THULEDATA;

const QUERY = `
  query Get($siteName: String!) {
    navigation(siteName: $siteName, language: "en") {
      languageSelector
    }
  }
`;

const LanguageSelector = () => {
  const [data, setData] = useState();
  const dataRef = useRef();
  function toggleLanguages(event) {
    event.currentTarget.classList.toggle('opened');
  }

  const getData = async () => {
    if (dataRef.current) return;

    try {
      const result = await client.query(QUERY, {
        siteName: SitecoreSiteName.toLowerCase(),
      });

      if (result.success) {
        setData(result.data);
      } else {
        console.error('Failed to fetch language data:', result.error);
      }
    } catch (error) {
      console.error('Error fetching language data:', error);
    }
  };

  useEffect(() => {
    dataRef.current = data;
  }, [data]);

  useEffect(() => {
    const triggerButtons = document.querySelectorAll('button[data-bs-target="#marketSelector"]');
    triggerButtons.forEach((item) => {
      item.addEventListener('click', getData);
    });

    const marketSelectorEl = document.getElementById('marketSelector');
    if (marketSelectorEl) {
      marketSelectorEl.addEventListener('show.bs.modal', getData);
    }

    return () => {
      triggerButtons.forEach((item) => {
        item.removeEventListener('click', getData);
      });
      if (marketSelectorEl) {
        marketSelectorEl.removeEventListener('show.bs.modal', getData);
      }
    };
  }, []);

  const marketSelectorEl = document.getElementById('marketSelector');
  if (!marketSelectorEl) return null;

  return createPortal(
    <div className="modal-dialog">
      <div className="modal-content">
        <div className="modal-header pt-7 pb-9 px-7 pt-lg-9 px-lg-9">
          <button
            type="button"
            className="btn-close btn-close-white"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div className="modal-body thule-container pb-7 pb-lg-9">
          <div className="main-content">
            {data && data.navigation && (
              <>
                {data.navigation.languageSelector.map((region) => (
                  <div key={region.Title} className="region-box pb-5 pb-lg-10">
                    <div className="region-title heading4">{region.Title}</div>
                    <div className="column-list-region">
                      {region.Cultures.map((country) => (
                        <div key={country.Title} className="country-box pb-7 pb-lg-5 pe-lg-6" onClick={toggleLanguages}>
                          <div className="country-name">
                            {country.Languages && country.Languages.length == 1 ? (
                              <a
                                className="set-cookie-on-click paragraph--s"
                                href={country.Languages[0].Path}
                                data-component-label="Change country"
                              >
                                {country.Title}
                              </a>
                            ) : (
                              <>
                                {country.Languages?.map((lang, i) => {
                                  return (
                                    <React.Fragment key={`${country.Title}_${lang.NativeLanguageName}`}>
                                      <a
                                        className="set-cookie-on-click paragraph--s"
                                        href={lang.Path}
                                        data-component-label="Change country"
                                      >
                                        {country.Title} ({lang.NativeLanguageName})
                                      </a>
                                      {i < country.Languages.length - 1 && <span> — </span>}
                                    </React.Fragment>
                                  );
                                })}
                              </>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </>
            )}
          </div>
        </div>
      </div>
    </div>,
    marketSelectorEl
  );
};

const root = createRoot(document.getElementById('REACT_languageSelector'));
root.render(
  <Sentry.ErrorBoundary>
    <LanguageSelector />
  </Sentry.ErrorBoundary>
);
